import { Injectable, Injector, OnDestroy } from "@angular/core";
import { Subject, Subscription, takeUntil } from "rxjs";
import { User } from "src/app/components/catalogs/user-catalog/services/user";
import { LoadingService } from "src/app/services/loading/loading.service";
import { SignalRService } from "src/app/services/signal-r/signal-r.service";
import { AppStateService } from "src/app/store/app-state-service";

@Injectable()
export class BaseState implements OnDestroy {
	private _ass!: AppStateService;
	protected _loading: LoadingService;
	protected _signalR: SignalRService;

	private subs: Subscription = new Subscription;
	public currentUser!: User | null;
	public destroy$ = new Subject<void>(); // 👈 cleanup signal

	constructor(
		protected injector: Injector,
	) {
		this._ass = this.injector.get(AppStateService);
		this._loading = this.injector.get(LoadingService);
		this._signalR = this.injector.get(SignalRService);
		this.loadCurrentUser();
		this.subscribeSender();
	}

	ngOnDestroy(): void {
		this.subs?.unsubscribe();
	}

	subscribeSender() {
		this._signalR.senderSubject.subscribe(sender => {
			if (sender)
				this._loading.setShowLoading(this.currentUser?.id == sender);
		});
	}

	loadCurrentUser() {
		this.subs = this._ass.AppState.pipe(takeUntil(this.destroy$)).subscribe(appstate => {
			if (appstate) {
				this.currentUser = appstate.currentUser;
				this.currentUserUpdated();

			}
		});
	}

	currentUserUpdated(): void {
		// this.method show be overridden in derived class to trigger other method when user updates!
	};

}